import { Theme } from '@emotion/react'
import styled from '@emotion/styled'

type L2ColumnLayoutProps = {
	columnCount: number|undefined
} & { theme: Theme }

export const L2ColumnLayout = styled.div(({theme, columnCount = 1}: L2ColumnLayoutProps) => ({
	display: 'grid',
	// Possible fix for temporary unequal two column layout quark
	// https://stackoverflow.com/questions/47601564/equal-width-columns-in-css-grid
	gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
	padding: theme.spacing(0, 6),
	columnGap: theme.spacing(6),
	marginBottom: theme.spacing(4),
}))

export const L2Column = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	rowGap: theme.spacing(4),
}))

// for backwards compatibility with old demos
export const L2ColumnLayoutColumn = L2Column
